import { FilterAdministrationContext } from '../../../../filter-administration.context';
import { Subscription } from 'rxjs';
import { Component, OnDestroy } from '@angular/core';
import { FilterDetailsComponent } from '../../../../filter-details-component.model';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';
import { FilterCondition } from '../../../../filter-administration.model';
import { TranslationService } from '@sdbn/common';
import { HttpService } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';

export class VisitorRole {
  id: string;
  nameDictionaryKey: string;
}

@Component({
  selector: 'app-visitor-visit-end-condition-editor',
  templateUrl: './visitor-visit-end-condition-editor.component.html',
  styleUrls: ['./visitor-visit-end-condition-editor.component.scss']
})
export class VisitorVisitEndConditionEditorComponent implements OnDestroy, FilterDetailsComponent {



  condition: FilterCondition;

  filterAdministrationContext: FilterAdministrationContext;
  filterAdministrationContextSubscription: Subscription;

  formGroup = new FormGroup({
    period: new FormControl(0, [])
  });

  resettingFormValues = false;

  constructor(
    public translationService: TranslationService,
    private httpService: HttpService
  ) {

    this.formGroup.addControl('visitorRole', new FormControl('', []));
    this.formGroup.valueChanges.subscribe(
      value => {
        this.condition.data = value.period;
        if (!this.resettingFormValues) {
          this.filterAdministrationContext.getFilter().dirty = true;
        }
      }
    );

  }

  ngOnDestroy() {
    if (this.filterAdministrationContextSubscription != null) {
      this.filterAdministrationContextSubscription.unsubscribe();
    }
  }

  setFilterAdministrationContext(filterAdministrationContext: FilterAdministrationContext) {
    this.filterAdministrationContext = filterAdministrationContext;
    this.condition = this.filterAdministrationContext.getSelectedFilterCondition();
    this.resetForm();
    this.filterAdministrationContextSubscription = this.filterAdministrationContext.contextChange$.subscribe(
      change => {
        try {
          if (change.key === 'selected-filter-condition-changed') {
            this.condition = this.filterAdministrationContext.getSelectedFilterCondition();
            this.resetForm();
          }
        } catch (error) {
          console.log(error);
        }
      }
    );
  }

  private resetForm() {
    this.resettingFormValues = true;
    this.formGroup.reset({ period: this.condition.data });
    this.formGroup.markAsPristine();
    this.resettingFormValues = false;
  }

}
